import React from "react";

function HomePage() {
  return (
    <div className="main-content">
      <main>
        <h1>Introduction to Web Development</h1>
        <p>
          The work invloved in designing, developing and deploying a web site is
          referred to as the Web Development. Web development can range from
          developing a simple single static page of plain text to complex web
          applications, electronic businesses, and social network services.
        </p>
        <p>
          There are three kinds of Web developer specialization: frontend
          developer, backend developer, and full-stack developer. Frontend
          developers are responsible for behavior and visuals that run in the
          user browser, while backend developers deal with the servers.
        </p>

        <h2>Frontend Roadmap</h2>
        <img
          width="100%"
          src="./images/frontend.png"
          alt="Frontend Web development roadmap"
        />
        <h2>Backend Roadmap</h2>
        <img
          width="100%"
          src="./images/backend.png"
          alt="Backend Web development roadmap"
        />
      </main>
    </div>
  );
}

export default HomePage;
